<template>
	<v-container id="regular-tables-view" fluid tag="section">
		<material-card icon="mdi-message-processing" icon-small title="لیست قالب های پیامک" color="accent" :loading="loading">
			<v-row>
				<v-col cols="12" style="padding:0 40px 40px">
					<v-tabs v-model="activeTab" @change="tabChanged" background-color="transparent" centered slider-color="yellow">
						<v-tab :key="0">قالب های در انتظار تایید ({{ pendingPatterns.length }})</v-tab>
						<v-tab :key="1">همه قالب ها ({{ countAll }})</v-tab>

						<v-tabs-items v-model="activeTab" touchless>
							<v-tab-item :key="0">
								<v-row>
									<v-col cols="12" lg="12">
										<v-text-field v-model="search" append-icon="mdi-magnify" label="اطلاعات مورد نظر جهت جستجو وارد کنید" single-line hide-details class="mb-5" />
									</v-col>
									<v-col cols="12">
										<v-data-table dense :headers="headers" :items="pendingPatterns" :items-per-page="500" :search="search" class="elevation-1">
											<template v-slot:item="row">
												<tr>
													<td>
														<div>{{ row.item.customer.name }}</div>
														<div>{{ row.item.customer.mobile }}</div>
													</td>
													<td>
														{{ row.item.title }}
													</td>
													<td>
														<div style="white-space:nowrap;text-overflow: ellipsis;overflow:hidden;max-width:200px">
															{{ row.item.pattern }}
														</div>
													</td>
													<td class="text-center">
														{{ row.item.isSystem ? 'بلی' : 'خیر' }}
													</td>
													<td class="text-center">
														{{ translateStatus(row.item.status) }}
													</td>
													<td style="white-space:nowrap;text-overflow: ellipsis;overflow:hidden;max-width:200px">
														{{ row.item.rejectReason }}
													</td>
													<td class="text-center">
														<v-btn class="mx-1" fab dark small color="secondary" @click="edit(row.item)">
															<v-icon dark>
																mdi-square-edit-outline
															</v-icon>
														</v-btn>
														<v-btn class="mx-1" fab dark small color="pink" @click="remove(row.item)">
															<v-icon dark>
																mdi-trash-can-outline
															</v-icon>
														</v-btn>
													</td>
												</tr>
											</template>
										</v-data-table>
									</v-col>
								</v-row>
							</v-tab-item>
							<v-tab-item :key="1">
								<v-row>
									<v-col cols="12" lg="12">
										<v-text-field v-model="search2" append-icon="mdi-magnify" label="اطلاعات مورد نظر جهت جستجو وارد کنید" single-line hide-details class="mb-5" />
									</v-col>
									<v-col cols="12">
										<v-data-table dense :headers="headers" :items="allPatterns" :items-per-page="500" :search="search2" class="elevation-1">
											<template v-slot:item="row">
												<tr>
													<td>
														<div>{{ row.item.customer.name }}</div>
														<div class="grey--text">{{ row.item.customer.mobile }}</div>
													</td>
													<td>
														{{ row.item.title }}
													</td>
													<td>
														<div style="white-space:nowrap;text-overflow: ellipsis;overflow:hidden;max-width:200px">
															{{ row.item.pattern }}
														</div>
													</td>
													<td class="text-center">
														{{ row.item.isSystem ? 'بلی' : 'خیر' }}
													</td>
													<td class="text-center">
														{{ translateStatus(row.item.status) }}
													</td>
													<td style="white-space:nowrap;text-overflow: ellipsis;overflow:hidden;max-width:200px">
														{{ row.item.rejectReason }}
													</td>
													<td class="text-center">
														<v-btn class="mx-1" fab dark small color="secondary" @click="edit(row.item)">
															<v-icon dark>
																mdi-square-edit-outline
															</v-icon>
														</v-btn>
														<v-btn class="mx-1" fab dark small color="pink" @click="remove(row.item)">
															<v-icon dark>
																mdi-trash-can-outline
															</v-icon>
														</v-btn>
													</td>
												</tr>
											</template>
										</v-data-table>
									</v-col>
								</v-row>
							</v-tab-item>

						</v-tabs-items>
					</v-tabs>

				</v-col>
			</v-row>
			<v-dialog v-model="dialogPattern" scrollable persistent max-width="450px">
				<v-card>
					<v-card-title>
						<span class="headline">مشخصات قالب پیامک</span>
						<v-spacer />
						<v-btn @click="dialogPattern = false" icon>
							<v-icon>mdi-close</v-icon>
						</v-btn>
					</v-card-title>
					<v-card-text>
						<v-form ref="form" class="mx-2" lazy-validation>
							<v-container>
								<v-row>
									<v-col cols="12">
										<v-text-field v-model="localData.title" outlined label="عنوان قالب*" :error-messages="errorMessages" :rules="[() => !!localData.title || 'عنوان قالب را وارد کنید']" required />
									</v-col>
									<v-col cols="12">
										<v-combobox v-model="localData.category" required :items="categories" label="دسته قالب" single-line :error-messages="errorMessages" item-text="title" item-value="id" />
									</v-col>
									<v-col>
										<v-textarea v-model="localData.pattern" outlined :error-messages="errorMessages" label="الگوی قالب*" :rules="[() => !!localData.pattern || 'قالب را وارد کنید']" required />
										<div style="font-size: 0.8rem;" class="mb-2">
											<div>نمونه پیامک:</div>
											<div v-html="sampleText" style="white-space: pre-line;">

											</div>
										</div>
									</v-col>
								</v-row>
								<v-row>
									<v-col cols="12">
										<v-textarea v-model="localData.rejectReason" outlined :error-messages="errorMessages" label="دلیل رد" />
									</v-col>
								</v-row>
							</v-container>
						</v-form>
					</v-card-text>
					<v-card-actions>
						<v-spacer />
						<v-btn color="blue" dark @click="submit(1)">
							تائید شود
						</v-btn>
						<v-btn color="red" dark @click="submit(2)">
							رد شود
						</v-btn>
					</v-card-actions>
				</v-card>
			</v-dialog>

		</material-card>
		<confirm-dlg ref="confirm" />
		<div class="py-3" />
	</v-container>
</template>

<script>
	import api from '@/util/app-api'
	import toast from '@/util/toast'

	export default {
		name: 'MembersView',
		components: {
			ConfirmDlg: () => import('@/components/Confirm'),
		},
		data() {
			return {
				activeTab: 0,
				countAll: 0,
				allPatternsFetched: false,
				pendingPatternsFetched: false,
				errorMessages: '',
				datePickerValidatioin: '',
				localData: {},
				selectedPattern: {},
				dialogPattern: false,
				search: '',
				search2: '',
				loading: false,
				headers: [
					{
						text: 'مشتری',
						align: 'start',
						sortable: true,
						value: 'firstName',
						width: 150
					}, {
						text: 'عنوان',
						align: 'start',
						sortable: true,
						value: 'title',
						width: 150
					}, {
						text: 'قالب',
						align: 'start',
						sortable: true,
						value: 'pattern',
					}, {
						text: 'سیستمی',
						align: 'center',
						sortable: true,
						value: 'isSystem',
					}, {
						text: 'وضعیت',
						align: 'center',
						sortable: true,
						value: 'status',
						width: 100
					}, {
						text: 'دلیل رد',
						align: 'start',
						sortable: true,
						value: 'rejectReason',
						width: 200,
					}, {
						text: 'عملیات ها',
						align: 'center',
						sortable: false,
						width: 150,
					},
				],
				allPatterns: [],
				pendingPatterns: [],
				replace: {
					'{نام مشتری}': 'مهدی قاسمی فرد',
					'{نام فروشگاه}': 'فروشگاه قاسمی فرد',
					'{مبلغ قسط}': 550000,
					'{شماره قسط}': 5,
					'{مبلغ واریز}': 550000,
					'{تاریخ واریز}': '1403-01-30',
					'{مانده وام}': 6500000,
					'{لینک پرداخت}': 'https://domain.ir/pop/100/1323213',
					'{بخش متغیر لینک پرداخت}': '100/1323213',
					'{مبلغ هر قسط}': 500000,
					'{مبلغ درخواستی}': 20000000,
					'{تعداد قسط}': 12,
					'{تاریخ درخواست}': '1403-05-05',
					'{نوع وام}': 'طرح بدون ضامن',
					'{شماره درخواست}': 1000,
					'{تاریخ تغییر وضعیت}': '1403-05-05',
					'{نام نماینده}': 'فروشگاه ما',
					'{وضعیت جدید}': 'اعطا شده',
					'{وضعیت جدید نماینده}': 'تسویه شده',
					'{سررسید واریز نماینده}': '1403-05-10',
					'{توسط نماینده با لیبل}': 'توسط نماینده داتیس',
					'{شماره پیگیری تراکنش}': '115100022233200',
					'{نام و نام خانوادگی}': 'محمد محمدی',
					'{نام کاربری}': 'admin',
					'{تاریخ}': '1403-05-05',
					'{تاریخ و ساعت}': '1403-05-05 10:15:06',
					'{آی پی}': '5.192.78.201',
					'{مرورگر}': 'chrome',
					'{رمز تاییدیه}': '54568',
					'{مبلغ باقیمانده}': 2500000,
					'{تعداد اقساط}': 12,
					'{بازپرداخت با بهره}': 27000000,
					'{مبلغ وام}': 25000000,
					'{تاریخ شروع}': '1404-05-01',
					'{شماره وام}': 102,
					'{کد تائیدیه}': 10562,
					'{مبلغ}': 650000000,
					'{تاریخ}': '1404-05-01',
					'{مانده اعتبار کیف پول}': 20000000,
					'{کد رهگیری}': '120002',
					'{نام تجاری نماینده}': 'بازرگانی قاسمی فرد',
				},
				categories: [
					{ value: 0, title: 'قسط' },
					{ value: 1, title: 'تغییر وضعیت' },
					{ value: 2, title: 'ورود به پنل' },
					{ value: 3, title: 'ثبت نام' },
					{ value: 4, title: 'کد تاییدیه ثبت نام' },
					{ value: 5, title: 'شارژ کیف پول' },
					{ value: 6, title: 'ثبت سفارش جدید' },
					{ value: 7, title: 'ثبت پرونده' },
					{ value: 8, title: 'برداشت از کیف پول' },
				],
			}
		},
		computed: {
			patternTags() {
				if (this.localData.category?.value === 1)
					return ['{نام مشتری}', '{نام فروشگاه}', '{مبلغ هر قسط}', '{مبلغ درخواستی}', '{تعداد قسط}', '{تاریخ درخواست}', '{نوع وام}', '{شماره درخواست}', '{تاریخ تغییر وضعیت}', '{نام نماینده}', '{وضعیت جدید}', '{وضعیت جدید نماینده}', '{سررسید واریز نماینده}', '{توسط نماینده با لیبل}']

				if (this.localData.category?.value === 2 || this.localData.category?.value === 3)
					return ['{نام و نام خانوادگی}', '{نام کاربری}', '{تاریخ}', '{تاریخ و ساعت}', '{آی پی}', '{مرورگر}', '{نام فروشگاه}', '{نام تجاری نماینده}']

				if (this.localData.category?.value === 4)
					return ['{رمز تاییدیه}', '{تاریخ}', '{تاریخ و ساعت}', '{آی پی}', '{مرورگر}', '{نام فروشگاه}']

				if (this.localData.category?.value === 5)
					return ['{نام مشتری}', '{نام فروشگاه}', '{لینک پرداخت}', '{تاریخ}']

				if (this.localData.category?.value === 6)
					return ['{نام مشتری}', '{نام فروشگاه}', '{کد ملی}', '{تاریخ}', '{کالای مورد درخواست}']

				if (this.localData.category?.value === 7)
					return ['{نام مشتری}', '{نام فروشگاه}', '{مبلغ هر قسط}', '{شماره وام}', '{نوع وام}', '{تاریخ شروع}', '{مبلغ وام}', '{بازپرداخت با بهره}', '{تعداد اقساط}', '{مبلغ باقیمانده}']

				if (this.localData.category?.value === 8)
					return ['{نام مشتری}', '{نام تجاری نماینده}', '{مبلغ}', '{تاریخ}', '{مانده اعتبار کیف پول}', '{کد تائیدیه}', '{کد رهگیری}']

				return ['{نام مشتری}', '{نام فروشگاه}', '{مبلغ قسط}', '{شماره قسط}', '{مبلغ واریز}', '{تاریخ واریز}', '{مانده وام}', '{لینک پرداخت}', '{بخش متغیر لینک پرداخت}', '{شماره پیگیری تراکنش}']
			},
			sampleText() {
				return this.convertPatternToSample(this.localData?.pattern)
			},
		},
		mounted() {
			this.tabChanged(0)
		},
		methods: {
			convertPatternToSample(pattern) {
				const replaceAll = (str, find, replace) => {
					return str.toString().replace(new RegExp(find, 'g'), replace)
				}
				if (!pattern)
					return ''
				for (var tag of this.patternTags) {
					pattern = replaceAll(pattern, tag, this.replace[tag])
				}
				return pattern
			},
			loadData(all) {
				this.loading = true
				let data = all || false
				api.get('superadmin/SmsPattern/list/' + data, null)
					.then(
						response => {
							if (all) {
								this.allPatterns = response.smsPatterns
								this.countAll = response.countAll
								this.allPatternsFetched = true
							} else {
								this.pendingPatterns = response.smsPatterns
								this.countAll = response.countAll
								this.pendingPatternsFetched = true
							}
						})
					.catch(err => {
						toast.error(err.message)
					})
					.finally(x => { this.loading = false })
			},
			edit(item) {
				api.get('superadmin/SmsPattern/get/' + item.id, null)
					.then(
						response => {
							this.localData = response
							this.localData.category = this.categories.find(x => x.value === this.localData.category)
							this.dialogPattern = true
						})
					.catch(err => {
						toast.error(err.message)
					})
			},
			submit(status) {
				if (!this.$refs.form.validate()) { return }

				let data = { ...this.localData }
				data.status = status
				data.category = this.localData.category.value
				api.post('superadmin/SmsPattern/' + (this.localData.id === 0 ? 'create' : 'edit'), data)
					.then(
						response => {
							toast.success('اطلاعات با موفقیت ذخیره شد.')
							this.loadData(this.activeTab == 1)
							this.dialogPattern = false
						})
					.catch(err => {
						toast.error(err.message)
					})
			},
			async remove(item) {
				if (!item) { return }

				if (await this.$refs.confirm.open(
					'توجه',
					'آیا از حذف این آیتم مطمئن هستید؟',
				)) {
					api.post('superadmin/SmsPattern/delete/' + item.id)
						.then(
							response => {
								toast.success('اطلاعات با موفقیت حذف شد.')
								this.allPatternsFetched = false
								this.pendingPatternsFetched = false
								this.pendingPatterns = this.activeTab == 1 ? [] : this.pendingPatterns
								this.allPatterns = this.activeTab == 0 ? [] : this.allPatterns
								this.loadData(this.activeTab == 1)
							})
						.catch(err => {
							toast.error(err.message)
						})
				}
			},
			tabChanged(tab) {
				if (tab == 1 && !this.allPatternsFetched)
					this.loadData(true)
				else if (tab == 0 && !this.pendingPatternsFetched)
					this.loadData(false)
			},
			translateStatus(status) {
				switch (status) {
					case 0:
						return 'در انتظار بررسی'
					case 1:
						return 'تائید شده'
					case 2:
						return 'رد شده'
					default:
						break
				}
			},
			updatePattern(pattern) {

			}
		},
	}
</script>
<style></style>
